// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2022/6/25
// +-------------------------------------------------------------
// |Time: 11:02
// +-------------------------------------------------------------

export default [
    {
        path: '/auth/node-list',
        name: "AdminNodeList",
        meta: {
            title: "节点列表"
        },
        component: () => import("@/views/Auth/Rule/Index")
    },
    {
        path: '/auth/role-list',
        name: "AdminRoleList",
        meta: {
            title: "角色列表"
        },
        component: () => import("@/views/Auth/Role/Index")
    },
    {
        path: '/auth/admin-list',
        name: "AdminList",
        meta: {
            title: "管理员列表"
        },
        component: () => import("@/views/Auth/Admin/Index")
    },
    {
        path: '/auth/admin-info',
        name: "AdminInfo",
        meta: {
            title: "个人中心"
        },
        component: () => import("@/views/Auth/Admin/AdminInfo.vue")
    }
]
